module.exports = "<div class=\"panel panel-default\">\n\n  <div class=\"panel-heading\">\n    <h3>Detalhes de Usuário</h3>\n  </div>\n  <div class=\"panel-body\">\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/usuario/usuario.component.html
// module id = ./src/app/usuario/usuario.component.html
// module chunks = main